import { useAppSelector } from "../../../redux/store";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { useTranslation } from "react-i18next";

const TransferDetails = () => {
  const booking = useAppSelector((state) => state.booking);
  const transfers = booking.transfers;
  const { t } = useTranslation();

  return (
    <div className="space-y-4 mb-4">
      <div className="flex space-x-6">
        <div className="w-1/2">
          <div className="flex justify-content-between">
            <div className="w-1/3">
              <h6 className="font-semibold text-gray-400">
                {t("bookingDetails.transfers.fromAirport")}
              </h6>
              <p className="font-bold">{transfers.departureDescription}</p>
            </div>
            <div className="w-1/3">
              <h6 className="font-semibold text-gray-400">Transfer</h6>
              <TrendingFlatIcon className="text-third" sx={{ fontSize: 40 }} />
            </div>
            <div className="w-1/3">
              <h6 className="font-semibold text-gray-400">
                {t("bookingDetails.transfers.toHotel")}
              </h6>
              <p className="font-bold">{transfers.accomodationCode}</p>
            </div>
          </div>
        </div>

        <div className="w-1/2">
          <div className="flex justify-content-between">
            <div className="w-1/3">
              <h6 className="font-semibold text-gray-400">
                {t("bookingDetails.transfers.fromHotel")}
              </h6>
              <p className="font-bold">{transfers.accomodationCode}</p>
            </div>
            <div className="w-1/3">
              <h6 className="font-semibold text-gray-400">Transfer</h6>
              <TrendingFlatIcon className="text-third" sx={{ fontSize: 40 }} />
            </div>
            <div className="w-1/3">
              <h6 className="font-semibold text-gray-400">
                {t("bookingDetails.transfers.toAirport")}
              </h6>
              <p className="font-bold">{transfers.departureDescription}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex space-x-6">
        <div className="w-1/2">
          <h6 className="font-semibold mb-2">
            {t("bookingDetails.transfers.transferInfo")}
          </h6>
          <p className="text-gray-400">
            {t("bookingDetails.transfers.notice1")}
          </p>
        </div>

        <div className="w-1/2">
          <h6 className="font-semibold mb-2">
            {" "}
            {t("bookingDetails.transfers.transferInfo")}
          </h6>
          <p className="mb-0">
            {t("bookingDetails.transfers.date")}:{" "}
            <span className="text-black">{transfers.pickupDate}</span>
          </p>
          <p className="mb-0">
            {t("bookingDetails.transfers.time")}:{" "}
            <span className="text-black">{transfers.pickupTime}</span>
          </p>
          <p>
            {t("bookingDetails.transfers.pickupLocation")}:{" "}
            <span className="text-black">{transfers.pickupDesc}</span>
          </p>
        </div>
      </div>

      <div className="text-gray-400 space-y-2">
        <p className="mb-0">{t("bookingDetails.transfers.notice2")}</p>
        <p className="text-warning fw-bold mb-0">
          {t("bookingDetails.transfers.important")}:
        </p>

        <ul className="space-y-2">
          <li>
            <span className="fw-bold text-black">
              {t("bookingDetails.transfers.notice3Title")}{" "}
            </span>
            <span>{t("bookingDetails.transfers.notice3")}</span>
          </li>
          <li>
            <span className="fw-bold text-black">
              {t("bookingDetails.transfers.notice4Title")}:{" "}
            </span>
            <span>{t("bookingDetails.transfers.notice4")}</span>
          </li>
          <li>
            <span className="fw-bold text-black">
              {t("bookingDetails.transfers.notice5Title")}:{" "}
            </span>
            <span>{t("bookingDetails.transfers.notice5")}</span>
          </li>
          <li>
            <span className="fw-bold text-black">
              {t("bookingDetails.transfers.notice6Title")}:{" "}
            </span>
            <span>{t("bookingDetails.transfers.notice6")}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TransferDetails;
